
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {
        constructor() {
            super();
        }
        mounted()
        {
            this.$EventBus.Mensajes.Aceptar = this.Abrir;
            this.$EventBus.onKeyDown.subscribe( e =>
            {
                if ( this.Abierto )
                {
                    if ( e.code == 'Enter' || e.key == 's' || e.key == 'S' )
                    {
                        this.Finalizar( true );
                    }
                    else if ( e.code == 'Escape' || e.key == 'n' || e.key == 'N' )
                    {
                        this.Finalizar( false );
                    }
                }
            } );
        }
        public Titulo: string = '';
        public Mensaje: string = '';
        public Aceptar: string = '';

        public MensajeAyuda: string = '';

        public async Abrir( Titulo: string = "", Mensaje: string = "", Aceptar: string = "Aceptar", MensajeAyuda: string = "" ): Promise<boolean> {

            this.Cargando = false;
            this.Ayuda = false;

            this.MensajeAyuda = MensajeAyuda;
            this.Titulo = Titulo;
            this.Mensaje = Mensaje;
            this.Aceptar = Aceptar;

            this.Abierto = true;

            await new Promise( ( resolve ) => {
                const resolver = () => { resolve(); this.$off( 'yesno-finished', resolver ); };
                this.$on( 'yesno-finished', resolver );
            } );

            this.Abierto = false;
            return this.Resultado;
        }

        public async Finalizar( b: boolean ) {
            this.Resultado = b;
            this.$emit( 'yesno-finished' );
        }

        public Cargando: boolean = false;
        public Abierto: boolean = false;
        public Resultado: boolean = false;
        public MouseOver: boolean = false;
        public Ayuda: boolean = false;
    }
